import { App } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  cloudOperatorAddJobDebug,
  setDefaultDebugOpenAdd,
} from "store/bailiff/(default)/debug/default_debug.action";
import { defaultDebugAllSelector } from "store/bailiff/(default)/debug/default_debug.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

//refine.
export const useActionDefaultDebugRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultDebugAllSelector);
  const total = data?.length || 0;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data, total };
};

//action
export const useActionDefaultDebug = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpen = () => {
    dispatch(setDefaultDebugOpenAdd(true));
  };

  const handleCancel = (form) => {
    form?.resetFields();
    dispatch(setDefaultDebugOpenAdd(false));
  };

  //
  const handleAddJob = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values) return message.error("Kết quả submit không hợp lệ");
        const job = values?.job;
        setLoading(true);
        dispatch(
          cloudOperatorAddJobDebug({ id: job }, (res) => {
            setLoading(false);
            if (res?.status === 200) {
              message.success("Thêm job debug thành công");
              handleCancel(form);
            }
            if (res?.status === 500) {
              message.error(res?.data);
            }
          }),
        );
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpen, handleCancel, handleAddJob };
};
